    <div class="container-fluid">
        <div class="row mt-4">
            <div class="col">
                <h5 class="blue"><i class="fas fa-money-bill-transfer"></i>&nbsp;Configuración global</h5>
            </div>
        </div>
        <hr style="margin-bottom: 0px;">
        
        <form #formConfigGlobal="ngForm" (ngSubmit)="formSubmit(formConfigGlobal)"  novalidate="" >  
            <div class="container-fuid" style="height: 210px; overflow-y: auto;  overflow-x: hidden; ">
                <div class="row justify-content-center align-items-center " style=" margin-right: 0px; margin-left: 0px; ">
                    <div class="col-lg-12 col-sm-12 col-md-12 col-12" >
                        <div class="form-group mt-3"  >
                            <label style="margin-bottom: 3px;">Cuenta contable de crédito: </label> <!-- pattern="^\d+(\.\d{1,2})?"-->
                            <!-- <input type="text"   autocomplete="off"   placeholder="Escribe la cuenta contable de crédito"
                            name="txtPrecio" #txtPrecio="ngModel" class="form-control  custom-input" 
                              [(ngModel)]="configGlobalRQ.valor" required>   -->
                              <p-inputMask mask="99-9999999-1MX1-999999-9999-9999-99"  autocomplete="off" name="txtGlobal" #txtGlobal="ngModel"
                              styleClass="form-control  custom-input" [style]="{'width': '100%', 'height': '30px'}" 
                               [(ngModel)]="configGlobalRQ.valor" placeholder="99-9999999-1MX1-999999-9999-9999-99" [required]="true">
                             </p-inputMask>
                        </div>
                    </div>
                </div>
        </div>
        <div class="row mt-2" style=" margin-right: 0px; margin-left: 0px; ">
            <div class="col text-end">
                <button type="button" (click)="onClose()" class="btn btn-sm rounded-button btn-secondary">
                            <i class="fa fa-arrow-left"></i>
                            Regresar
                </button>
                <button type="submit" [disabled]="!formConfigGlobal.form.valid" class="side-space btn btn-sm rounded-button btn-success">
                    Aceptar
                    <i class="fa fa-check"></i>
                </button>
            </div>
        </div>
        </form> 
    </div>